import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Button } from 'react-bootstrap';

const logoPath = `${process.env.PUBLIC_URL}/images/logos/Logo_PROMEDIC-07.png`;

const NotFound = () => {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#f8f9fa',
      }}
    >
      <Container className="text-center py-5">
        <img
          src={logoPath}
          alt="ProMedic Group"
          style={{ maxWidth: '180px', marginBottom: '2rem' }}
        />
        <h1
          style={{
            fontSize: '6rem',
            fontWeight: 700,
            color: '#0d6efd',
            lineHeight: 1,
          }}
        >
          404
        </h1>
        <h2 className="mb-3 text-dark">Pagina no encontrada</h2>
        <p className="text-muted mb-4" style={{ maxWidth: '420px', margin: '0 auto 2rem' }}>
          La pagina que buscas no existe o fue movida. Verifica la direccion o regresa al inicio.
        </p>
        <Button as={Link} to="/" variant="primary" size="lg">
          <i className="bi bi-house-door me-2"></i>
          Ir al inicio
        </Button>
      </Container>
    </div>
  );
};

export default NotFound;
